import { observer } from 'mobx-react'
import { DetailedHTMLProps, FC, HTMLAttributes, useContext } from 'react'
import { StoreContext } from '@components/App'
import { DraggableBorder } from '@styles/generic.styles'
import { WindowContainer } from '../TabbedCodeView.styles'
import { EntityWindow } from './WindowTypes/EntityWindow'
import { ClientWindow } from './WindowTypes/ClientWindow'
import { GetStartedWindow } from './WindowTypes/GetStartedWindow'
import { JSONPreviewWindow } from './WindowTypes/JSONPreviewWindow'
import { UserDetailsWindow } from './WindowTypes/UserDetailsWindow'
import { GroupDetailsWindow } from './WindowTypes/GroupDetailsWindow'
import { PermissionDetailsWindow } from './WindowTypes/PermissionDetailsWindow'

interface WindowComponentProps {
  horizontalDragBarProps?: Omit<DetailedHTMLProps<HTMLAttributes<HTMLHRElement>, HTMLHRElement>, 'ref'>
  isHorizontalDragging?: boolean
  horizontalPosition?: 'left' | 'right'
}

export const WindowComponent: FC<WindowComponentProps> = observer(
  ({ horizontalDragBarProps, isHorizontalDragging, horizontalPosition }) => {
    const store = useContext(StoreContext)
    const { windowsActiveTabs, isHorizontalSplit } = store.CodeViewState

    const activeTab = windowsActiveTabs[horizontalPosition]

    const renderWindowBody = () => {
      switch (activeTab?.type) {
        case 'get-started':
          return <GetStartedWindow />
        case 'entity':
          return <EntityWindow side={horizontalPosition} />
        case 'client':
          return <ClientWindow side={horizontalPosition} />
        case 'user':
          return <UserDetailsWindow side={horizontalPosition} />
        case 'group':
          return <GroupDetailsWindow side={horizontalPosition} />
        case 'permission':
          return <PermissionDetailsWindow side={horizontalPosition} />
        case 'json-preview':
          return <JSONPreviewWindow side={horizontalPosition} />
        default:
          // return <>debug info: empty {horizontalPosition} window</>
          return <></>
      }
    }

    return (
      <WindowContainer
        $isOnlyChild={!isHorizontalSplit}
        onClick={() => {
          store.CodeViewState.setCurrentlyFocusedWindow(horizontalPosition)
        }}
      >
        {renderWindowBody()}
        {horizontalDragBarProps && (
          <DraggableBorder {...horizontalDragBarProps} $align="right" $isDragging={isHorizontalDragging} />
        )}
      </WindowContainer>
    )
  },
)
